import { SvgIcon } from '@material-ui/core'

export const DotsIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 22 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
        fill="currentColor"
      />
      <path
        d="M20 4C21.1046 4 22 3.10457 22 2C22 0.89543 21.1046 0 20 0C18.8954 0 18 0.89543 18 2C18 3.10457 18.8954 4 20 4Z"
        fill="currentColor"
      />
      <path
        d="M11 4C12.1046 4 13 3.10457 13 2C13 0.89543 12.1046 0 11 0C9.89543 0 9 0.89543 9 2C9 3.10457 9.89543 4 11 4Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
